import { render } from "./Tournaments.vue?vue&type=template&id=4fa83936&scoped=true"
import script from "./Tournaments.vue?vue&type=script&lang=js"
export * from "./Tournaments.vue?vue&type=script&lang=js"

import "./Tournaments.vue?vue&type=style&index=0&id=4fa83936&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa83936"]])

export default __exports__